import articlePage from "@faire/web-api/routes/support/articles/articleId";
export var DoNotHaveRequestedInfoIA = function DoNotHaveRequestedInfoIA(strictLocalize, articles) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    learnMoreLink: articles !== null && articles !== void 0 && articles.Account.NOT_OPEN ? articlePage(articles.Account.NOT_OPEN.id) : undefined
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return VERIFY_YOUR_ACCOUNT(strictLocalize);
    },
    getDescription: function getDescription() {
      return [DO_NOT_HAVE_INFO_NEEDED(strictLocalize)];
    }
  };
};
var VERIFY_YOUR_ACCOUNT = function VERIFY_YOUR_ACCOUNT(strictLocalize) {
  return strictLocalize({
    id: "ici5fB",
    defaultMessage: [{
      "type": 0,
      "value": "Informatie verstrekken om je account te verifiëren"
    }]
  });
};
var DO_NOT_HAVE_INFO_NEEDED = function DO_NOT_HAVE_INFO_NEEDED(strictLocalize) {
  return strictLocalize({
    id: "fbjw9s",
    defaultMessage: [{
      "type": 0,
      "value": "Heb je niet alle informatie die nodig is om je account te verifiëren? Dat is niet erg. Laat het ons weten en we houden je bestelling tot 30 dagen na de besteldatum vast terwijl je de vereiste informatie verzamelt."
    }]
  });
};